import ActionCable from 'actioncable';
import JwtService from '@/common/services/jwt.service';

export default {
  createConnection() {
    let webSocketURL;
    const token = JwtService.getToken();
    if (process.env.NODE_ENV === 'development') {
      webSocketURL = `ws://${window.location.hostname}:3000/cable?token=${btoa(token)}`;
    } else {
      webSocketURL = `${process.env.VUE_APP_WS_URL}?token=${btoa(token)}`;
    }
    return ActionCable.createConsumer(webSocketURL);
  },
  createSubscription(app = null, channel, id, callback) {
    if (app === null) {
      const App = this.createConnection();
      return App.subscriptions.create({ channel, id }, callback);
    }

    return app.subscriptions.create({ channel, id }, callback);
  },
};
